import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../component/BasicBitmapCountUp";
import {RoadKillGameAssets} from "../RoadKillGameAssets";
import {IBetWinData, IWinHighLightData, RoadKillGameData} from "../server/RoadKillData";
import {RoadKill} from "../RoadKill";
import {RoadKillWinConfigs} from "../RoadKillWinConfigs";
import {TimelineLite} from "gsap"
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {RoadKillSound} from "../sound/RoadKillSound";
import {RoadKillGameConfig} from "../RoadKillGameConfig";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {RoadKillModel} from "../server/RoadKillModel";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {RoadKillSymbol} from "../reels/RoadKillSymbol";
import {RoadKillSymbolStates} from "../component/enums/RoadKillEnums";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {RoadKillIndividualSymWinView} from "./RoadKillIndividualSymWinView";

export class RoadKillWinView extends PIXI.Container implements StageLayer {
    private _individualSymWinWaysCont: PIXI.Container;
    private _waysCount: PIXI.Text;
    private _initialWinCountUp: BasicBitmapCountUp;
    private _mainTL: TimelineLite | null;
    private winIndx: number = 0;
    private _winAmountExplosion: TimelineSprite;

    constructor() {
        super();
        this.name = "RoadkillWinView";
        this.init();
    }
    public resetIndividualSymWinViewCont():void{
        this._individualSymWinWaysCont.removeChildren();
    }

    public playInitialWinAnimation(): TimelineLite {
        if (this._mainTL) {
            this._mainTL = null;
        }
        if (!this._mainTL) {
            this._mainTL = new TimelineLite({
                onComplete: () => {
                    RoadKill.keypadPlugin.setWin(RoadKill.model.gameData.accumulatedRoundWin, this.isTotalWin(), BelowStakeWinRestriction.isWinBelowStake());
                }
            });
        }
        this.winIndx = RoadKillUtils.winIdx().ratio;
        if (this.winIndx == -1) this.winIndx = RoadKillWinConfigs.WIN_RATIOS.normalWin.length - 1;
        this._mainTL.add(RoadKill.jumpingWildView.hideShowAllSW());
        if (RoadKill.model.gameData.doMassiveWildThisSpin) {
            this._mainTL.add(RoadKill.massiveWinView.playSpecificAnimation("win", false, true));
            this._mainTL.add(RoadKill.massiveWinView.playSpecificAnimation("win_idle", true, false));
        }
        this._mainTL.add(this.winPositions());
        this._mainTL.add(this.addWinCountUpToTimeline());

        if ((RoadKillWinConfigs.getWinType(RoadKill.model.winRatio) !== RoadKillWinConfigs.TINY && RoadKillWinConfigs.getWinType(RoadKill.model.winRatio) !== RoadKillWinConfigs.SMALL)) {
            this._mainTL.to(this, {duration: 1});
        } else {
            if (RoadKill.model.mode === RoadKillGameMode.NORMAL && !RoadKill.autoPlayPlugin.isAutoplayRound) {
                this._mainTL.to(this, {duration: 1});
            }
        }

        this._mainTL.add(() => {
            this._winAmountExplosion.visible = false;
        })
        if (RoadKill.model.gameData.totalAnimalHitsSFS === 20 || RoadKill.model.nextMode === RoadKillGameMode.RESPIN) {
            this._mainTL.add(this.hideCountUp());
        }

        return this._mainTL;
    }

    public playCountUp(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            gameData: RoadKillGameData = RoadKill.model.gameData,
            winType: string = RoadKillWinConfigs.getWinType(RoadKill.model.winRatio),
            countUpDur: number = RoadKillWinConfigs.getCountupDuration(winType),
            isBelowWinRestriction: boolean = BelowStakeWinRestriction.isWinBelowStake();

        tl.add(() => {
            this._initialWinCountUp.visible = true;
            this._initialWinCountUp.alpha = 1;
        }, 0);

        tl.add([this._initialWinCountUp.getCountAnimation(0, gameData.totalSpinWinnings, countUpDur), () => {
            if (winType === RoadKillWinConfigs.MEDIUM) {
                RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_MEDIUM_COUNT_UP);
            }
            if (winType === RoadKillWinConfigs.LARGE) {
                RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_LARGE_COUNT_UP);
            }
        }]);
        if (!isBelowWinRestriction) {
            if (winType === RoadKillWinConfigs.SMALL || winType === RoadKillWinConfigs.TINY) {
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_TINY_SMALL);
                });
            }
            if (winType === RoadKillWinConfigs.MEDIUM) {
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_MEDIUM);
                });
            }
            if (winType === RoadKillWinConfigs.LARGE) {
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_LARGE);
                });
            }
        }
        tl.add(() => {
            this._initialWinCountUp.stopAt(gameData.totalSpinWinnings);
        });
        tl.add(() => {
            RoadKill.keypadPlugin.setWin(RoadKill.model.gameData.accumulatedRoundWin, this.isTotalWin(), BelowStakeWinRestriction.isWinBelowStake());
        })
        return tl;
    }

    public onResize() {
    }

    public onReelStart(durr: number = RoadKillGameConfig.HIDE_AND_ALPHA_DURATION): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(this.hideCountUp(durr));
        return tl;
    }

    public hideCountUp(durr: number = RoadKillGameConfig.HIDE_AND_ALPHA_DURATION): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this._initialWinCountUp.visible = false;
                this._waysCount.visible = false;
            }
        });
        if (RoadKill.model.gameData && RoadKillWinConfigs.getWinType(RoadKill.model.winRatio) === RoadKillWinConfigs.TINY) {
            tl.to(this, {duration: 0.1});
        }
        tl.to([this._initialWinCountUp, this._waysCount], {
            alpha: 0,
            duration: durr
        })
        return tl;
    }

    protected addWinCountUpToTimeline(): TimelineLite {
        let countUpDuration: number = RoadKillWinConfigs.getCountupDuration(RoadKillWinConfigs.getWinType(RoadKill.model.winRatio));
        let animDurr: number = countUpDuration ? 0.5 : 0.3;

        const gameModel: RoadKillModel = RoadKill.model,
            splittedDurr = countUpDuration / gameModel.allBetWayWinDataHighlight.longest,
            noWinAlpha: number = 0.45,
            tl: TimelineLite = new TimelineLite(),
            winType: string = RoadKillWinConfigs.getWinType(RoadKill.model.winRatio);


        let startPos: number = 0,
            waysDelay: number = countUpDuration ? 0.2 : 0,
            playWildSoundOnce: boolean = true;
        const perReel: number = countUpDuration ? RoadKill.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? splittedDurr * 0.7 : splittedDurr : 0;

        if (countUpDuration) {
            for (let reel = 0; reel < gameModel.allBetWayWinDataHighlight.reelWinPositions.length; reel++) {
                for (let row = 0; row < gameModel.allBetWayWinDataHighlight.reelWinPositions[reel].length; row++) {
                    const sym: RoadKillSymbol | undefined = RoadKillUtils.getSymbol(reel, row);
                    if (sym) {
                        const hits: boolean = gameModel.allBetWayWinDataHighlight.reelWinPositions[reel][row];
                        tl.add(() => {
                            if (hits) {
                                if ((winType === RoadKillWinConfigs.TINY || winType === RoadKillWinConfigs.SMALL)) {
                                    sym.glowPreHit(hits, animDurr, this.winIndx);
                                } else {
                                    this.playWinAnimation(reel, row);
                                }
                            }
                            sym.markNonWin(!hits, 0.55, animDurr);
                        }, startPos);

                        if (!(winType === RoadKillWinConfigs.TINY || winType === RoadKillWinConfigs.SMALL) && playWildSoundOnce && RoadKill.model.evaluatedArea[reel][row] === "W") {
                            tl.add(() => {
                                RoadKill.soundPlayer.playTrack(RoadKillSound.WILD_CIRCLE);
                            }, startPos + 0.02);
                            playWildSoundOnce = false;
                        }
                    }
                }
                if (reel < gameModel.allBetWayWinDataHighlight.longest)
                    startPos += perReel;
            }
            if (RoadKill.backgroundElements.getMultiplierValue() >= 2 && RoadKill.model.mode !== RoadKillGameMode.NORMAL) {
                tl.add(() => {
                    RoadKill.backgroundElements.playMultiplierAnim().timeScale(2);
                }, startPos)
            }
        }

        for (let reel = 0; reel < gameModel.allBetWayWinDataHighlight.reelWinPositions.length; reel++) {
            for (let row = 0; row < gameModel.allBetWayWinDataHighlight.reelWinPositions[reel].length; row++) {
                const sym: RoadKillSymbol | undefined = RoadKillUtils.getSymbol(reel, row);
                if (sym) {
                    const hits: boolean = gameModel.allBetWayWinDataHighlight.reelWinPositions[reel][row];
                    tl.add(() => {
                        if (winType === RoadKillWinConfigs.TINY || winType === RoadKillWinConfigs.SMALL) {
                            sym.glowPreHit(hits, animDurr, this.winIndx);
                        }
                        if (!hits) sym.setNonAlpha(noWinAlpha);
                    }, startPos);
                    tl.add(() => sym.markNonWin(!hits, noWinAlpha, animDurr / 3), startPos);
                }
            }
        }
        if(RoadKill.model.normalWinDataHighlight.length===1){
            const winData:IWinHighLightData=RoadKill.model.normalWinDataHighlight[0],
                symPosForWinWays:[number,number]=[0,0];
            for (let reel = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                for (let row = 0; row < posRow.length; row++) {
                    if(posRow[row]){
                        symPosForWinWays[0]=reel;
                        symPosForWinWays[1]=row;
                    }
                }
            }
            const winWaysPos:PIXI.Point=RoadKillUtils.getSymbol(symPosForWinWays[0], symPosForWinWays[1]).position,
                winWaysObj:RoadKillIndividualSymWinView=new RoadKillIndividualSymWinView(winData.multipliedAmount,winData.numberOfCombinations,new PIXI.Point(winWaysPos.x,winWaysPos.y+RoadKillGameConfig.SYMBOL_HEIGHT+30));
            this._individualSymWinWaysCont.addChild(winWaysObj);
            tl.add(()=>{
                winWaysObj.showWinAndWays(0.4);
            },0);
        }


        if (!BelowStakeWinRestriction.isWinBelowStake()) {
            tl.add(this.playCountUp(), 0);

            tl.add(() => {
                this._initialWinCountUp.bounceHit(RoadKillUtils.getCountUpBounceIntensity());
                if (winType === RoadKillWinConfigs.MEDIUM || winType === RoadKillWinConfigs.LARGE) {
                    this._winAmountExplosion.visible = true;
                    this._winAmountExplosion.getAnimation();
                }
            }, countUpDuration);

            tl.add(() => {
                this.showWinWaysText();
            }, countUpDuration + waysDelay);

        }

        // Reset and remove blackness.
        if (countUpDuration)
            tl.to(this, {duration: animDurr + countUpDuration + waysDelay + this.winIndx > 2 ? 0.5 : 0}, 0);

        return tl;
    }

    protected winPositions(): TimelineLite {
        const gameData: RoadKillModel = RoadKill.model,
            animationDurr: number = 0.5,
            belowWinStake: boolean = BelowStakeWinRestriction.isWinBelowStake(),
            noWinAlpha: number = 0.45,
            bigWin: boolean = this.isBigWin(),
            tl: TimelineLite = new TimelineLite(),
            winType: string = RoadKillWinConfigs.getWinType(RoadKill.model.winRatio),
            winGrps: IWinHighLightData[] = gameData.normalWinDataHighlight!;

        if (belowWinStake) {
        } else if (winGrps.length == 1) return tl;

        let startPos: number = 0;
        for (let groups: number = 0; groups < winGrps.length; groups++) {
            const winData: IWinHighLightData = winGrps[groups],
                symPosForWinWays:[number,number]=[0,0];

            for (let reel = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                for (let row = 0; row < posRow.length; row++) {
                    const sym: RoadKillSymbol | undefined = RoadKillUtils.getSymbol(reel, row);
                    if (sym) {
                        if(posRow[row]){
                            symPosForWinWays[0]=reel;
                            symPosForWinWays[1]=row;
                        }
                        tl.add(() => sym.markNonWin(!posRow[row], noWinAlpha, animationDurr / 2), startPos);
                        tl.add(() => {
                            sym.glowPreHit(posRow[row], animationDurr, winData.winLvl);
                        }, startPos);
                    }
                }
            }
            const winWaysPos:PIXI.Point=RoadKillUtils.getSymbol(symPosForWinWays[0], symPosForWinWays[1]).position,
             winWaysObj:RoadKillIndividualSymWinView=new RoadKillIndividualSymWinView(winData.multipliedAmount,winData.numberOfCombinations,new PIXI.Point(winWaysPos.x,winWaysPos.y+RoadKillGameConfig.SYMBOL_HEIGHT+30));
            this._individualSymWinWaysCont.addChild(winWaysObj);
            tl.add(()=>{
                winWaysObj.showWinAndWays(0.5);
            });
            if (!belowWinStake) {
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.WIN_SYM_HIGHLLIGHT[groups]);
                }, startPos);
            }
            startPos += animationDurr / 1.75;
        }

        if (bigWin) {
            for (let reel = 0; reel < gameData.allBetWayWinDataHighlight.reelWinPositions.length; reel++) {
                for (let row = 0; row < gameData.allBetWayWinDataHighlight.reelWinPositions[reel].length; row++) {
                    const sym: RoadKillSymbol | undefined = RoadKillUtils.getSymbol(reel, row);
                    if (sym) {
                        const hits: boolean = gameData.allBetWayWinDataHighlight.reelWinPositions[reel][row];
                        if (hits) tl.add(() => sym.markNonWin(!hits, noWinAlpha, 0.5), startPos + 0.1);
                    }
                }
            }

        }
        tl.to(this, {duration: animationDurr / (bigWin ? 1.75 : 1.5)});
        return tl;
    }

    private playWinAnimation(reelId: number, symId: number): TimelineLite {
        const symbol: RoadKillSymbol = RoadKillUtils.getSymbol(reelId, symId);
        const tl: TimelineLite = new TimelineLite();
        if (RoadKill.model.data.evaluatedArea[reelId][symId] === "W") {
            tl.add(symbol.playWildOverlayWinAnimation(), 0);
        } else {
            if (RoadKillGameConfig.WILD_SYMBOLS.indexOf(symbol.symbolName) > -1) {
                tl.add(symbol.playWildOverlayWinAnimation(), 0);
            }
            tl.add(symbol.setState(RoadKillSymbolStates.WIN, "", 0, true), 0);
        }
        tl.to(this, {duration: 0.3});
        return tl;
    }

    private showWinWaysText(durr: number = 0.2): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onStart: () => {
                const totalWinWays: number = this.getTotalWays();
                this._waysCount.text = totalWinWays > 1 ? totalWinWays.toString().concat(" " + RoadKill.apiPlugin.translations.translate("Ways Won")) : totalWinWays.toString().concat(" " + RoadKill.apiPlugin.translations.translate("Way Won"));
            }
        });
        this._waysCount.alpha = 0
        this._waysCount.visible = true;
        tl.to(this._waysCount, {alpha: 1, duration: durr});
        return tl;
    }

    private getTotalWays(): number {
        const betWaysWin: IBetWinData[] = RoadKill.model.betWayWins;
        let totalWays: number = 0
        betWaysWin.forEach((individualBetWin) => {
            totalWays += individualBetWin.numberOfCombinations;
        });
        return totalWays;
    }

    private isTotalWin(): boolean {
        return !(RoadKill.model.mode === RoadKillGameMode.NORMAL && RoadKill.model.nextMode === RoadKillGameMode.NORMAL);
    }

    private createWaysCount(): PIXI.Text {
        const pixiText: PIXI.Text = new PIXI.Text("", new PIXI.TextStyle(RoadKillGameConfig.WAYS_STYLE));
        pixiText.alpha = 0;
        pixiText.visible = false;
        pixiText.anchor.set(0.5, 0.5);
        pixiText.position.set(360, 410);
        return pixiText;
    }

    private init(): void {
        this._initialWinCountUp = this.createCountUp();
        this._waysCount = this.createWaysCount();
        this._winAmountExplosion = this.createWinAmountExplosion();
        this._individualSymWinWaysCont = new PIXI.Container();
        this.onResize();
        this.addChild(this._winAmountExplosion,this._individualSymWinWaysCont, this._initialWinCountUp, this._waysCount);
    }

    private createWinAmountExplosion(): TimelineSprite {
        const timelineSprite: TimelineSprite = new TimelineSprite(RoadKill.assetLoader.getTextures("winAmountExplosion"));
        timelineSprite.position.set(360, 313);
        timelineSprite.anchor.set(0.5);
        timelineSprite.visible = false;
        return timelineSprite;
    }

    private createCountUp(): BasicBitmapCountUp {
        const countUp: BasicBitmapCountUp = new BasicBitmapCountUp({
            fontName: RoadKillGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 115,
            tint: 0xffffff
        }, 720);
        countUp.visible = false;
        countUp.alpha = 0;
        countUp.position.set(360, 313);
        return countUp;
    }

    private isBigWin(): boolean {
        return RoadKill.model.winRatio > RoadKillWinConfigs.WIN_RATIOS.bigWin[0].ratio * 1.2;
    }
}